import styled from "styled-components";

export const StyledTooltipCard = styled.div`
  background: #262641;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
  pointer-events: none;
  /* Fixed + viewport coords: safe when portaled into positioned #root-modals */
  position: fixed;
  width: max-content;
  /* Above ModalOverlay (11) / ModalT1 (12) — both also portal to #root-modals */
  z-index: 1000;

  &.limit {
    max-width: 75vh;
  }

  &::after {
    background: #262641;
    content: "";
    height: 12px;
    left: var(--arrow-left, 50%);
    margin-left: -6px;
    position: absolute;
    top: -6px;
    transform: rotate(45deg);
    width: 12px;
  }

  &[data-placement="top"]::after {
    bottom: -6px;
    top: auto;
  }
`;
